/*
 *
 * MapPage actions
 *
 */

import { MAP_CHANGEDTYPE, MAP_MOVED, MAP_CHANGEDMODE } from './constants';

export function mapMoved(map) {
  const center = map.getCenter();
  return {
    type: MAP_MOVED,
    zoom: map.getZoom(),
    center,
  };
}

export function mapChangedType(layer) {
  return {
    type: MAP_CHANGEDTYPE,
    mapType: layer.options.id,
  };
}

export function mapChangedMode(travelMode) {
  return {
    type: MAP_CHANGEDMODE,
    travelMode,
  };
}
